import { useState, useRef, useEffect } from 'react';

const inputStyle = { width: "100%", border: "1px solid #e5e7eb", borderRadius: 8, padding: "9px 12px", fontSize: 13, boxSizing: "border-box", outline: "none", transition: "border 0.2s" };

export default function CategoryPicker({ value, onChange, options, getGroup, theme: t, isDark, error, placeholder, disabled }) {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setIsOpen(false);
        setSearch("");
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [isOpen]);

  const filtered = search
    ? options.filter(c => c.toLowerCase().includes(search.toLowerCase()))
    : options;

  const handleSelect = (c) => {
    onChange(c);
    setIsOpen(false);
    setSearch("");
  };

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <div
        onClick={() => { if (!disabled) { setIsOpen(!isOpen); setSearch(""); } }}
        style={{ ...inputStyle, cursor: disabled ? "default" : "pointer", display: "flex", justifyContent: "space-between", alignItems: "center", borderColor: error ? "#fca5a5" : undefined, color: value ? t.text : t.textMuted, background: t.inputBg, opacity: disabled ? 0.5 : 1 }}
      >
        <span>{value || placeholder || "Select a category..."}</span>
        <span style={{ fontSize: 10, color: t.textMuted }}>{isOpen ? "\u25B2" : "\u25BC"}</span>
      </div>
      {isOpen && (
        <div style={{ position: "absolute", top: "100%", left: 0, right: 0, zIndex: 60, background: t.cardBg, border: "1px solid " + t.cardBorder, borderRadius: 8, boxShadow: "0 8px 24px rgba(0,0,0,0.12)", marginTop: 4, maxHeight: 250, overflow: "hidden", display: "flex", flexDirection: "column" }}>
          <div style={{ padding: 8, borderBottom: "1px solid " + t.cardBorder }}>
            <input
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="Search categories..."
              autoFocus
              style={{ ...inputStyle, fontSize: 12, padding: "7px 10px", background: t.inputBg, color: t.text }}
            />
          </div>
          <div style={{ overflowY: "auto", maxHeight: 200 }}>
            {filtered.length === 0 && (
              <div style={{ padding: "12px", fontSize: 12, color: t.textMuted, textAlign: "center" }}>No categories found</div>
            )}
            {filtered.map(c => (
              <div
                key={c}
                onClick={() => handleSelect(c)}
                style={{
                  padding: "9px 14px", fontSize: 13, cursor: "pointer",
                  color: value === c ? "#2563eb" : t.text,
                  background: value === c ? (isDark ? "#1e3a5f" : "#eff6ff") : "transparent",
                  fontWeight: value === c ? 600 : 400,
                  borderBottom: "1px solid " + (isDark ? "#1e293b" : "#f8fafc"),
                }}
                onMouseOver={e => { if (value !== c) e.currentTarget.style.background = t.tableHover; }}
                onMouseOut={e => { if (value !== c) e.currentTarget.style.background = "transparent"; }}
              >
                <span>{c}</span>
                <span style={{ fontSize: 10, color: t.textMuted, marginLeft: 8 }}>{getGroup(c)}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
